module.exports = __webpack_public_path__ + "static/media/chinese.e8e8e5e4.svg";